import AutomationError from './AutomationError';
class AutomaticInvoicingDisabled extends AutomationError {
    constructor(options) {
        super('The investor has automatic invoicing disabled.', options);
    }
}
export default AutomaticInvoicingDisabled;
